var map = {
	"./Controls_Folder 2.ico": 7427,
	"./Controls_Folder.ico": 4150,
	"./Cross.ico": 4146,
	"./Customize_computer.ico": 4895,
	"./Dark_Agent.ico": 1277,
	"./Deskette_Drive 2.ico": 8342,
	"./Deskette_Drive.ico": 8327,
	"./Desktop.ico": 3579,
	"./Dialog.ico": 898,
	"./Disc_Drive 2.ico": 6184,
	"./Disc_Drive.ico": 4770,
	"./Earth_16.ico": 7944,
	"./Folder.ico": 8691,
	"./Help_book.ico": 788,
	"./Mail.ico": 7493,
	"./Mute_volume.ico": 226,
	"./New_letter.ico": 8352,
	"./Notepad_writing.ico": 2331,
	"./Printers_folder 2.ico": 8402,
	"./Printers_folder.ico": 8795,
	"./Program_Folder.ico": 5917,
	"./Settings.ico": 2544,
	"./User_view.ico": 9629,
	"./Volume Wave.ico": 2840,
	"./Volume.ico": 299,
	"./Volume_Up.ico": 4602,
	"./Web-document.ico": 919,
	"./WordPad_document.ico": 2538,
	"./find.ico": 5559,
	"./internet.ico": 6560,
	"./login_key.ico": 4172,
	"./my_computer.png": 8666,
	"./my_documents.ico": 5377,
	"./recycle_bin.png": 3068,
	"./run.ico": 8746,
	"./shut_down_computer.ico": 3353,
	"./trash_full.ico": 5432,
	"./web_shortcut.ico": 3045,
	"./win-logo/android-chrome-48x48.png": 8778,
	"./win-logo/apple-touch-icon.png": 7331,
	"./win-logo/favicon-16x16.png": 8554,
	"./win-logo/favicon-32x32.png": 1999,
	"./win-logo/favicon.ico": 8614,
	"./win-logo/mstile-150x150.png": 4910,
	"./windows.png": 7558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5605;